module.exports = __webpack_public_path__ + "img/3.40ed6ff9.png";